import {media} from '@modifi/ui'
import styled, {FlattenSimpleInterpolation, css} from 'styled-components'

import {colorMap} from '../common'

type WrapperProps = {
  backgroundColor?: string
}

export const Wrapper = styled.div<WrapperProps>`
  ${({backgroundColor}): FlattenSimpleInterpolation | string =>
    backgroundColor && colorMap?.[backgroundColor]
      ? css`
          background-color: ${colorMap?.[backgroundColor]};
        `
      : ''}
  padding: 80px 24px;
  ${media.min.sm`
    padding: 80px 54px
  `}

  ${media.min.lg`
    padding: 80px 108px;
  `}
`

export const FormWrapper = styled.span`
  & > div {
    box-shadow: none;
  }
`
